import React, { useEffect } from 'react';
import cn from 'classnames';
import styles from './Housing.scss';
import { pluralize, formatNumber } from 'utils';
import ChessLinkContainer from '../ChessLinkContainer';
import iconArrow from 'assets/images/icons/icon-arrow.svg';
import { useTranslation } from 'react-i18next';
import { gaEvent, trackGA } from 'services/ga';

const digits = (number) => (number ? formatNumber(number) : '...');

const Housing = ({ className, building, print, client, profile, objectType }) => {
  const { t } = useTranslation();
  const { pavilions, status, country } = building.data;
  const { country_currency_symbol: currency } = country;

  const handleTrackEvent = ({ eventName, eventLabel, eventContent }) => {
    const { title, id } = building.data;

    trackGA(
      gaEvent[eventName]({
        eventLabel,
        eventContent,
        productType: objectType,
        productName: title,
        productID: id,
        user_id: profile.id,
      })
    );
  };

  useEffect(() => {
    handleTrackEvent({
      eventName: 'buildingInfoBlocksShow',
      eventLabel: 'korpusa',
    });
  }, []);

  const list = pavilions.map((pavilion, index) => {
    const {
      name,
      construction_finished,
      construction_ending,
      year_built,
      count_flats,
      cost_min,
      cost_max,
      min_square_housing,
      max_square_housing,
    } = pavilion;

    return (
      <div className={cn(styles.Inner, { [styles.InnerPrint]: print })} key={index}>
        <div className={styles.InnerLeft}>
          <div className={styles.Name}>
            {t('components.building.main.housing.name', { name: name || '' })}
            {print ? (
              status === 2 ? (
                <div className={styles.Stopped}>
                  <span>{t('components.building.main.housing.stopped')}</span>
                </div>
              ) : (
                <div className={styles.RoomCount}>
                  <span>
                    {count_flats
                      ? `(${count_flats} ${pluralize(
                          count_flats,
                          t('components.building.main.housing.flat1'),
                          t('components.building.main.housing.flat2'),
                          t('components.building.main.housing.flat3')
                        )})`
                      : ''}
                  </span>
                </div>
              )
            ) : null}
            {print ? null : (
              <div
                className={cn(styles.Status, { [styles.StatusFinished]: !!construction_finished })}
              >
                <span className={styles.Text}>
                  {construction_finished
                    ? t('components.building.main.housing.finished')
                    : year_built == 0
                    ? t('components.building.main.housing.inProgress')
                    : `${construction_ending} / ${year_built}`}
                </span>
              </div>
            )}
          </div>
          <div className={styles.FlatsInfo}>
            {count_flats && status === 2 ? (
              <div className={styles.Stopped}>
                <span>{t('components.building.main.housing.stopped')}</span>
              </div>
            ) : (
              <span>
                {count_flats
                  ? `${count_flats} ${pluralize(
                      count_flats,
                      t('components.building.main.housing.flat1'),
                      t('components.building.main.housing.flat2'),
                      t('components.building.main.housing.flat3')
                    )}`
                  : ''}
              </span>
            )}

            {status !== 2 ? (
              <span>
                {count_flats ? (
                  <span className={cn(styles.Prices, { [styles.PricesStopped]: status === 0 })}>
                    {', '}
                    {t('components.building.main.housing.prices', {
                      costMin: digits(cost_min),
                      costMax: digits(cost_max),
                      areaMin: digits(min_square_housing),
                      areaMax: digits(max_square_housing),
                      currency,
                    })}
                  </span>
                ) : (
                  <span className={styles.Prices}>
                    <div className={styles.Message}>
                      <span>
                        {status === 2
                          ? t('components.building.main.housing.stopped')
                          : building.data.type_id === 2
                          ? t('components.building.main.housing.soldAllHouses')
                          : t('components.building.main.housing.soldAllFlats')}
                      </span>
                    </div>
                  </span>
                )}
              </span>
            ) : (
              ''
            )}
          </div>
        </div>
        {!client ? (
          <div
            className={styles.InnerRight}
            onClick={() =>
              handleTrackEvent({
                eventName: 'buildingChessLinkClick',
                eventContent: `korpus_${name}`,
              })
            }
          >
            <ChessLinkContainer query={`section=${index}.0`} className={styles.ChessLink}>
              <span className={cn(styles.TabletHidden, styles.MobileVisible)}>
                {t('components.building.main.housing.see')}
              </span>
              <span className={cn(styles.TabletVisible, styles.MobileHidden)}>
                {t('components.building.main.housing.see1')}
              </span>{' '}
              {t('components.building.main.housing.chess')}
              <img src={iconArrow} alt="" />
            </ChessLinkContainer>
          </div>
        ) : null}
      </div>
    );
  });

  return (
    <div
      className={cn(
        styles.Housing,
        className,
        { [styles.HousingClient]: client },
        { [styles.HousingPrint]: print }
      )}
    >
      <h3 className={cn(styles.Title, { [styles.TitlePrint]: print })}>
        {t('components.building.main.housing.corps', {
          number: print ? '' : `(${pavilions.length})`,
        })}
      </h3>
      {list}
    </div>
  );
};

export default Housing;



// WEBPACK FOOTER //
// ./src/components/Building/Main/Housing/Housing.js